var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":`self-evaluation-modal-${_vm.mode}`,"title":_vm.$t('self-evaluation.personal-assessment'),"size":"lg","hide-footer":"","no-close-on-backdrop":""}},[(_vm.needEvaluation)?_c('personality-evaluation-form',{attrs:{"student":_vm.user.id,"user":_vm.user},on:{"close":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }